import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomingDocs  {
    _originalTypeClassName = "zERP.BO.IncomingDocs";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomingDocs.translate = translateService;
}
this.IncomingDocsKey = null;
this._key = this.IncomingDocsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _IncomingDocsKey:any;
get IncomingDocsKey(): any {
    return this._IncomingDocsKey;
  }
set IncomingDocsKey(value: any) {
    this._IncomingDocsKey = value;
    this._key = value;
  }

static FillIncomeClassificationMultipleLines(invoice: any): any{let invoiceClassificationType;
invoiceClassificationType.invoiceMark = invoice?.Mark;
for (let _iline = 0; _iline < (invoice?.InvoiceDetails == null ? 0 : invoice?.InvoiceDetails.length); _iline++) {let line = invoice?.InvoiceDetails[_iline];let details;details.lineNumber = line?.LineNumber;details.incomeClassificationDetailData?.addRange(Domain.TransformHelper.InterfaceIncomeClassificationTransformer(line?.IncomeClassification));invoiceClassificationType.invoicesIncomeClassificationDetails?.add(details);}
return invoiceClassificationType;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.IncomingDocsKey == null || $this.IncomingDocsKey == 0;
            }


}